export enum Status {
    Unchanged = 0,
    Changed,
    New,
    Deleted,
}

export namespace Status {
    export function setChanged(obj: { Status: Status }) {
        if (obj.Status == Status.Unchanged) {
            obj.Status = Status.Changed;
        }
    }
}

export enum Cardinality {
    One = 0,
    Many,
}

export enum PropertyTypeCategoryDTO {
    Default,
    Embedded,
    EmbeddedMedium,
    Enumeration,
    DataType,
}
